import { Suspense, useEffect, useMemo } from 'react';

import AccordionLoader from '../components/reusable/AccordionLoader';
import RightSection from '../components/reusable/right-panel';
import { usePanelHistoryContext } from '../context/panel-history';
import { useRightPanelContext } from '../context/right-section';
import { rightSectionComponentMap } from './right-section-component-map';

const GlobalRightSection = () => {
	const rightPanel = useRightPanelContext();

	const panelHistoryProps = usePanelHistoryContext();

	const { current: currentAction, goTo } = panelHistoryProps;

	// Watch rightPanel.action and push to panel history if it's a new entry
	useEffect(() => {
		// A back/forward restore re-applies an older action — consume the flag and
		// skip, otherwise the restore itself would push a duplicate history entry
		// and truncate the forward stack.
		if (rightPanel.isRestoringRef?.current) {
			rightPanel.isRestoringRef.current = false;
			return;
		}
		if (
			rightPanel?.action &&
			(rightPanel.action.component !== currentAction?.action.component || rightPanel.action.type !== currentAction.action.type)
		) {
			goTo(rightPanel);
		}
	}, [rightPanel?.action]);

	useEffect(() => {
		if (currentAction?.action.component) {
			const componentEntry = rightSectionComponentMap[currentAction.action.component]?.find((entry) =>
				entry.action.includes(currentAction?.action.type)
			);
			componentEntry?.component?.preload?.();
		}
	}, [currentAction?.action.component, currentAction?.action.type]);

	useEffect(() => {
		if (!rightPanel.openSection) {
			panelHistoryProps.reset();
			sessionStorage.clear();
		}
	}, [rightPanel.openSection]);

	const Component = useMemo(() => {
		if (!currentAction?.action.component || !currentAction?.action.type) return null;

		const { component: path, type } = currentAction.action;

		const componentEntry = rightSectionComponentMap[path]?.find((entry) => entry.action.includes(type));

		if (!componentEntry) {
			console.error(`Component not found for path: ${path}, type: ${type}`);
			return null; // Or a fallback component
		}

		return componentEntry.component;
	}, [currentAction?.action.component, currentAction?.action.type]);

	if (!Component) return null;

	return (
		<RightSection panelHistoryProps={panelHistoryProps}>
			<Suspense
				fallback={
					<div
						style={{ width: '100%', height: '100vh' }}
						className='f-column text-center align-items-center justify-content-center'
					>
						<AccordionLoader size={72} />
					</div>
				}
			>
				{Component ? <Component /> : null}
			</Suspense>
		</RightSection>
	);
};

export default GlobalRightSection;
